// @flow
import type { Dictionary } from '../types'

/** Utility function mimicking Object.value whilst maintaining type annotations */
export function values<T> (dictionary: Dictionary<T>): T[] {
  // $FlowFixMe - Object.values returns mixed[] and we are forcing it back to T[]
  return Object.values(dictionary)
}
